<!--新增、修改报表弹窗-->
<template>
	<el-dialog append-to-body :close-on-press-escape="false" :modal-append-to-body="false" :close-on-click-modal="false" :title="title" :visible.sync="dialogFormVisible" width="740px" class="manageReport">
		<el-form v-if="dialogFormVisible" :model="formSave" ref="formSaveRef" label-width="100px" label-position="right" :rules="rules" :disabled="onlyread">
			<div class="grid-content bg-purple">
				<el-form-item label="品牌名称 : " prop="brandIdentify">
					<el-select v-model="formSave.brandIdentify" placeholder="品牌名称" style="width:100%">
						<el-option v-for="item in brandOptions" :key="item.brandIdentify" :label="item.brandName" :value="item.brandIdentify">
						</el-option>
					</el-select>
				</el-form-item>
			</div>
			<div class="grid-content bg-purple">
				<el-form-item required label="报表状态 : ">
					<el-radio-group v-model="formSave.reportState">
						<el-radio name='type' label="1">正常</el-radio>
						<el-radio name='type' label="0">锁定</el-radio>
					</el-radio-group>
				</el-form-item>
			</div>
			<div class="grid-content bg-purple-light">
				<el-form-item label="报表名称 : " prop="reportName">
					<el-input v-model="formSave.reportName" autocomplete="off" placeholder="报表名称" style="width: 100%"></el-input>
				</el-form-item>
			</div>
			<div class="grid-content bg-purple">
				<el-form-item label="数据源类型 : " prop="dataOrigin">
					<el-select v-model="formSave.dataOrigin" placeholder="数据源类型" style="width:100%">
						<el-option v-for="item in dataOriginOptions" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
			</div>
			<div class="grid-content bg-purple">
				<el-form-item label="数据适配器 : " prop="dataAdapter">
					<el-select v-model="formSave.dataAdapter" placeholder="数据适配器" style="width:100%">
						<el-option v-for="item in dataAdapterOptions" :key="item.adapterId" :label="item.adapterCode" :value="item.adapterId">
						</el-option>
					</el-select>
				</el-form-item>
			</div>
			<div class="grid-content bg-purple">
				<el-form-item label="报表类型 : " prop="reportType">
					<el-select v-model="formSave.reportType" placeholder="数据适配器" style="width:100%">
						<el-option label="sql" value="sql"></el-option>
						<el-option label="自定义" value="custom"></el-option>
					</el-select>
				</el-form-item>
			</div>
			<div class="grid-content bg-purple-light">
				<el-form-item label="报表描述 : " prop="reportDescript">
					<el-input v-model="formSave.reportDescript" type="textarea" :rows="2" placeholder="报表描述" style="width: 100%"></el-input>
				</el-form-item>
			</div>
			<div class="grid-content bg-purple-light">
				<el-form-item label="报表内容 : " prop="reportContent">
					<el-input v-model="formSave.reportContent" type="textarea" placeholder="报表内容" style="width: 100%" id="reportSQL"
					:autosize="{ minRows: 2, maxRows: 10}"
					@blur="ableLabel=false" @focus="ableLabel=true"></el-input>

					<div class="label_box" v-if="ableLabel">
						<el-button v-for="(item, index) in this.label" :key="index" @mousedown.native="(e)=>dispatchLabel(e,item)" size="mini">{{item.itemName}}</el-button>
					</div>
					<div class="remark">
						<p @click="remarkDetail = !remarkDetail" style="cursor: pointer;"><i class="el-icon-info"style="color:#409EFF"></i>查询条件配置规则
							<!-- example：${has(sessionTime_begin)?(" and m.create_time>='"+sessionTime_begin+" 00:00:00'"):""} --></p>
						<div :class="{showRemark: remarkDetail}" class="remarkDetail">
							<p>
								1) 配置时间条件：请使用配置的code加"_begin"和"_end"，系统会自动识别并替换参数
								${has(sessionTime_begin)?(" and m.create_time>='"+sessionTime_begin+" 00:00:00'"):""}
								${has(sessionTime_end)?(" and m.create_time>='"+sessionTime_end+" 00:00:00'"):""}
							</p>
							<p>
								2) 配置分页：
								${has(pageNumber,pageSize)?(" limit ${pageNumber}, ${pageSize}"):""}
							</p>
						</div>
					</div>

				</el-form-item>
			</div>

			<div class="grid-content bg-purple-light">
				<el-form-item label="序号 : " prop="sequenceNumber">
					<el-input v-model="formSave.sequenceNumber" placeholder="序号" style="width: 100%"></el-input>
				</el-form-item>
			</div>
		</el-form>
		<div slot="footer" class="dialog-footer" v-if="!onlyread">
			<el-button @click="getCancelBtn()">取 消</el-button>
			<el-button type="primary" @click="commit" :loading="loading">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import {
	validateReportName
} from "@/utils/validator";

export default {
	name: "manageReport",
	components: {},
	data() {
		return {
			needRangeList: ["date","datetime","month"],
			reportId: "",
			loading: false,
			dialogFormVisible: false,
			onlyread: false,
			formSave: {
				brandIdentify: "",
				reportState: "1",
				reportName: "",
				dataOrigin: "",
				dataAdapter: "",
				reportDescript: "",
				reportContent: "",
				sequenceNumber: ""
			},
			title: "新增报表",
			// 品牌下拉项
			brandOptions: [],
			// 数据源下拉项
			dataOriginOptions: [{
				code: "JDBC",
				name: "JDBC"
			}, {
				code: "JREmptyDataSource",
				name: "JREmptyDataSource"
			}, {
				code: "CUSTOMER",
				name: "自定义"
			}],
			// 适配器下拉项
			dataAdapterOptions: [],
			operType: "",
			rules: {
				brandIdentify: [{
					required: true,
					validator: (rule, value, callback) => {
						if (!value) {
							return callback(new Error("请选择品牌名称"));
						}else{
							return callback();
						}
					},
					trigger: 'blur'
				}],
				reportState: [{ required: false, trigger: 'blur' }],
				reportName: [{ required: true, validator: validateReportName, trigger: 'blur' }],
				dataOrigin: [{ required: true, validator: (rule, value, callback) => {
						if (!value) {
							return callback(new Error("请选择数据源类型"));
						}else{
							return callback();
						}
					},trigger: 'blur' }],
				dataAdapter: [{ required: true, validator: (rule, value, callback) => {
						if (!value) {
							return callback(new Error("请选择数据适配器"));
						}else{
							return callback();
						}
					},trigger: 'blur' }],
				reportDescript: [{ trigger: 'blur' }],
				reportContent: [{ trigger: 'blur' }],
				// sequenceNumber: [{ required: true, validator: (rule, value, callback) => {
				// 		if (!value) {
				// 			return callback(new Error("请选输入序号"));
				// 		}else{
				// 			return callback();
				// 		}
				// 	},trigger: ['blur', "change"] }],
			},
			remarkDetail: false,
			ableLabel: false,
			label: [],
		}
	},
	computed: {
		...mapGetters([
			'userInfo',
		]),
	},
	watch: {
		operType: function() {
			this.setFormState();
		},
	},
	mounted() {
		this.requestBrandList();
		this.requestAdapterList();
	},
	methods: {
		init() {
			this.resetFormData();
			this.dialogFormVisible = true;
		},
		// 请求品牌下拉
		requestBrandList() {
			this.$api.getBrandSelist({
				data: {},
				orderBy: '',
				pageNum: 1,
				pageSize: 100
			}).then(res => {
				if (!res) return;
				this.brandOptions = [{
					brandIdentify: "common",
					brandName: "通用品牌"
				}].concat(res.list);
			})
		},

		// 请求适配器下拉选项
		requestAdapterList() {
			this.$api.reportDefinitionListAdapter()
				.then(rs => {
					if (!rs) return;
					this.dataAdapterOptions = rs.data
				})
		},

		commit() {
			console.log("commit")
			this.$refs.formSaveRef.validate((valid) => {
				if (valid) {
					this.loading = true;

					let queryData = Object.assign({}, this.formSave);

					let executeFunction;
					if (this.operType == "create") {
						executeFunction = this.$api.reportDefinitionDefinitionAddJson;
					} else if (this.operType == "update") {
						executeFunction = this.$api.reportDefinitionDefinitionEditJson;
					}

					executeFunction({
						adapterId: queryData.dataAdapter,
						brandId: queryData.brandIdentify,
						reportDatasouceType: queryData.dataOrigin,
						reportDesc: queryData.reportDescript,
						reportFile: "",
						reportHandler: "",
						reportId: this.reportId,
						reportName: queryData.reportName,
						reportState: queryData.reportState,
						reportText: queryData.reportContent,
						reportType: queryData.reportType,
						seqNum: queryData.sequenceNumber || 0,
					}).then(res => {
						if (!res) return false;
						this.$message.success("操作成功");
						this.$emit("requestList");
						this.dialogFormVisible = false;
					}).finally(() => {
						this.loading = false;
					})
				} else {
					return false;
				}
			});
		},
		// 取消按钮回调
		getCancelBtn() {
			this.resetFormData();
			this.$refs.formSaveRef.resetFields()
			this.dialogFormVisible = false;
			// this.$emit("requestList");
		},


		// 新增报表
		showAddReport() {
			this.operType = "create";
			this.init();
		},
		// 更新报表
		showUpdateDetail(reportData) {
			// console.log(reportData);
			this.operType = "update";
			this.init();
			this.setFormdata(reportData);
			this.initLabel(reportData.reportId);
		},
		// 查看报表
		showReportDetail(reportData) {
			this.operType = "detail";
			this.init();
			this.setFormdata(reportData);
		},
		setFormdata(reportData) {
			this.reportId = reportData.reportId;
			this.formSave = {
				brandIdentify: reportData.brandId,
				reportState: reportData.reportState,
				reportName: reportData.reportName,
				dataOrigin: reportData.reportDatasouceType,
				dataAdapter: reportData.adapterId,
				reportDescript: reportData.reportDesc,
				reportContent: reportData.reportText,
				sequenceNumber: reportData.seqNum.toString(),
				reportType: reportData.reportType
			};
		},

		setFormState() {
			switch (this.operType) {
				case "create":
					this.title = "新增报表";
					this.onlyread = false;
					break;
				case "update":
					this.title = "修改报表";
					this.onlyread = false;
					break;
				case "detail":
					this.title = "报表配置详情";
					this.onlyread = true;
					break;
				default:
					return;
			}
		},

		resetFormData() {
			this.formSave = {
				brandIdentify: "",
				reportState: "1",
				reportName: "",
				dataOrigin: "",
				dataAdapter: "",
				reportDescript: "",
				reportContent: "",
				sequenceNumber: "",
				reportType: ""
			};
			this.label = [];
		},

		// 请求 sql输入框下的快捷标签
		initLabel(){
			this.$api.reportExtractParamsAction({
				reportId: this.reportId
			}).then(rs => {
				if (!rs) return false;
				let { itemList } = rs.data;
				let _itemList = itemList.map(item=>item.item);
				let _label = [];
				for(let data of _itemList){
					if(this.needRangeList.includes(data.showType)){
						_label.push({
							itemCode: data.itemCode+"_begin",
							itemName: data.itemName+"(开始)"
						})
						_label.push({
							itemCode: data.itemCode+"_end",
							itemName: data.itemName+"(结束)"
						})
					}else{
						_label.push({
							itemCode: data.itemCode,
							itemName: data.itemName
						})
					}
				}
				// console.log(_label);
				this.label = _label;
			})
		},
		dispatchLabel(event,item){
			event.preventDefault();
			this.insertInputTxt("reportSQL",`\${${item.itemCode}}`);
		},
		insertInputTxt(id,insertTxt) {
			var elInput = document.querySelector(`#${id}`);
			var startPos = elInput.selectionStart;
			var endPos = elInput.selectionEnd;
			if (startPos === undefined || endPos === undefined) return

			var txt = elInput.value;
			var result = txt.substring(0, startPos) + insertTxt + txt.substring(endPos)

			elInput.value = result;
			elInput.selectionStart = startPos + insertTxt.length;
			elInput.selectionEnd = startPos + insertTxt.length;
			elInput.focus();

		}
	}
}
</script>

<style lang="scss" scoped>
.manageReport{
	::v-deep .el-dialog__body{
		padding-bottom: 1px;
	}
	::v-deep .el-dialog__footer{
		padding-top: 0;
	}
}
.remark{
	width: calc(85%);
	position: relative;
	&>p{
		line-height: 20px;
		color: gray;
	}
}
.label_box{
	display: flex;
	flex-wrap: wrap;
	align-content: space-between;
	margin-bottom: 10px;
	&>button{
		margin-top: 10px;
		margin-right: 10px;
		margin-left: 0;
	}
}

::v-deep .el-textarea__inner#reportSQL{
	&::-webkit-scrollbar{
		width: 1rem;
	}
	&::-webkit-scrollbar-thumb {
		background: #eee;
	  border-radius: 3px;
	}
	&::-webkit-scrollbar-track{
		background: #fafafa;
		// background: red;
		// border: 0;
	}
	&::-webkit-resizer::before{
		content:"123";
		box-shadow: 1px 1px 1px red;
		// background: red;
		// border: 0;
	}
}
.remarkDetail{
	line-height: 20px;
	overflow: hidden;
	height: 0;
}
.showRemark{
	height: auto;
}
</style>